
import React from 'react';
import Header from '@/components/layout/Header';
import LoadingState from '@/components/football/LoadingState';

interface HomeStatusProps {
  isLoading: boolean;
  isError: boolean;
}

const HomeStatus: React.FC<HomeStatusProps> = ({ isLoading, isError }) => {
  if (isLoading) {
    return (
      <>
        <Header />
        <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
          <LoadingState />
        </div>
      </>
    );
  }
  
  if (isError) {
    return (
      <>
        <Header />
        <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
          <div className="text-center text-red-600">
            Error loading data. Please try again.
          </div>
        </div>
      </>
    );
  }
  
  return null;
};

export default HomeStatus;
